import React, { Component } from 'react';
import axios from 'axios'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class AddDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }


    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    expectedDateSelectOnChange = (date) => {
        console.log("expected ++++++++:dateSelectOnChange");
        console.log("expected date:" + date);
        console.log("expected date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            expectedDateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    sendDeliveryDate = () => {
        console.log("++++++++:markDeliveryDate");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (this.props.projectId == '') {
            alert("No projectId Person")
        } else if (this.props.user.email == '') {
            alert("No Entered By Provided")
        } else if (this.state.dateNum == '') {
            alert("No Date Selected")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'setDateDelivered', {
                apiKey: "sendDeliveryDate",
                projectId: this.props.projectId,
                enteredBy: this.props.user.email,
                dateDelivered: this.state.dateNum
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");

                        alert(response.data.message);

                        if(this.props.viewOnMobile){
                            console.log("vx2 props.viewOnMobile is true doing nothing...")
                        }else{
                            history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                        }
                        
                    } else {
                        console.log("FAILED");

                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const datePaidButton = this.state.dateNum != ''
            ? <Button>SET DELIVERY DATE</Button>
            : ''

        const expectedDatePaidButton = this.state.expectedDateNum != ''
            ? <Button>SET EXPECTED DATE</Button>
            : ''

            
        const enterPaymentDate =
            <div>
                <Divider horizontal>{'ENTER DATE ORDER WAS DELIVERED'}</Divider>

                <Form size='large' onSubmit={this.sendDeliveryDate}>
                    <Segment stacked>
                        <h3>ENTER DATE ORDER WAS DELIVERED'</h3>

                        <SingleDatePicker
                            date={this.state.date} // momentPropTypes.momentObj or null
                            //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                            onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                            focused={this.state.focused} // PropTypes.bool
                            isOutsideRange={() => false}
                            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                        />
                        <h2>{this.state.dateString}</h2>
                        {datePaidButton}
                    </Segment>
                </Form>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            {enterPaymentDate}
     
        </div>);
    }
}

export default AddDate;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/AddDates.js